<template>
  <div class="app-wrapper" :class="sidebarClass">
    <div v-if="device === 'mobile' && !isCollapse" class="drawer-bg" @click="handleClickOutside"/>
    <side-bar class="sidebar-container"></side-bar>
    <div class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <nav-bar></nav-bar>
        <tags-view v-if="tagsView"></tags-view>
      </div>
      <app-main :class="fixedHeader ? 'app-container' : ''"></app-main>
      <right-panel>
        <setting></setting>
      </right-panel>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Setting from './components/Setting.vue'
import RightPanel from '../components/RightPanel'
import SideBar from './SideBar/index'
import NavBar from './NavBar'
import TagsView from './components/TagsView/index'
import AppMain from './AppMain'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'Layout',
  components: {
    SideBar,
    NavBar,
    TagsView,
    AppMain,
    RightPanel,
    Setting
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapGetters(['isCollapse', 'device']),
    // 侧边栏样式
    sidebarClass () {
      return {
        // 隐藏侧边栏
        hideSidebar: this.isCollapse,
        // 展示侧边栏
        openSidebar: !this.isCollapse,
        // 是否使用手机端样式
        mobile: this.device === 'mobile'
      }
      // isCollapse ? 'hideSidebar' : 'openSidebar'
    },
    // 是否开启标签页
    tagsView () {
      return this.$store.getters.tagsView
    },
    // 是否固定顶部导航栏
    fixedHeader () {
      return this.$store.getters.fixedHeader
    },
    // 使用设备
    device () {
      return this.$store.getters.device
    }
  },

  methods: {
    // 关闭侧边栏
    handleClickOutside () {
      this.$store.dispatch('app/closeSideBar')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../style/scss/variable.scss";

.app-wrapper {
  height: 100%;
  width: 100%;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$base-sidebar-width});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
 width: calc(100% - 54px);
}

.sidebarHide .fixed-header {
  width: 100%;
}

.app-container {
  position: relative;
  padding-top: 85px;
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}
</style>
